<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{ caption }}<strong v-if="required" class="required">*</strong>
        </template>
        <template #input>
            <input :class="{ 'input-component': true, 'active': active}" v-model="internalValue" @focus="toggleActive"
                   @blur="compute" :disabled="disabled" @keydown.enter="compute"/>

        </template>
    </form-input-layout>
</template>

<script>


import FormInputLayout from "./FormInputLayout";
import FormInputMixin from "./FormInputMixin";
import { evaluate } from 'mathjs'
import { prepareExpression } from "@/utils/number-input";

export default {
    name: "FormNumberInput",
    components: {FormInputLayout},
    mixins: [FormInputMixin],
    props: {
        helpItemCode: String
    },
    methods: {
        compute() {

            const expression = prepareExpression(this.internalValue);

            try {
                const result = evaluate(expression);
                this.internalValue = result;
                this.$emit('input', result);
            } catch (e) {
                this.internalValue = '';
                console.log('ERROR', e)
            }

            this.toggleActive();
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.internalValue = newVal;
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/global";

.input-component {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid var(--input-border-color);
    background-color: var(--input-background-color);
    border-radius: 5px;
    color: var(--input-font-color);
    padding: 2px 10px 2px 10px;
    outline: none;
    width: 100%;
    font-family: Source Sans Pro;
}

.active {
    color: var(--input-active-font-color);
    background-color: var(--input-active-background-color);
    border: 1px solid var(--input-active-border-color);
}

.required {
    color: var(--accent-color);
}
</style>